import * as React from 'react';

const H6ChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 20v-6h7v6h2V6h-2v6H5V6H3v14h2zM19 6.7c-.7 0-1.2.2-1.7.6.1-1.2.7-1.9 1.6-1.9.5 0 .9.1 1.3.4l.6-1c-.4-.3-.9-.6-1.9-.6-1.4 0-2.9 1-2.9 3.6 0 2.2 1.1 3.3 2.7 3.3 1.5 0 2.5-.9 2.5-2.3 0-1.5-1-2.1-2.2-2.1zm-.3 3.3c-.8 0-1.3-.6-1.3-1.7.3-.3.8-.6 1.4-.6.8 0 1.1.5 1.1 1.1-.1.7-.5 1.2-1.2 1.2z"
        />
    </svg>
);

H6ChunkySvg.displayName = 'H6ChunkySvg';
export default H6ChunkySvg;
